import { UnlockConditions } from 'features/RewardCard/RewardCard.types';
import { TFunction } from 'react-i18next';

export const getUnlockedSum = (unlockConditions?: UnlockConditions): number => {
	if (unlockConditions?.totalSumToUnlock != null && unlockConditions?.sumLeftToUnlock != null) {
		return unlockConditions.totalSumToUnlock - unlockConditions.sumLeftToUnlock;
	}
	return 0;
};

export const getUnlockedBets = (unlockConditions?: UnlockConditions): number => {
	if (unlockConditions?.totalBetsToUnlock != null && unlockConditions?.betsLeftToUnlock != null) {
		const { totalBetsToUnlock, betsLeftToUnlock } = unlockConditions;

		if (betsLeftToUnlock < 0) {
			return totalBetsToUnlock;
		}

		return totalBetsToUnlock - betsLeftToUnlock;
	}

	return 0;
};

export const removeRewardProgressLocalData = (bonusId: number, bonusUnlocked?: boolean) => {
	const prefixesToKeep = ['RewardAmountUnlocked', 'RewardBetsUnlocked'];
	const idToKeep = bonusId.toString();

	Object.keys(localStorage).forEach((key) => {
		const [prefix, id] = key.split('--');

		// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
		if (prefixesToKeep.includes(prefix!) && (id !== idToKeep || bonusUnlocked === false)) {
			localStorage.removeItem(key);
		}
	});
};

export const getLocalProgressData = (key: string) => {
	const localKey = localStorage.getItem(key);
	if (!localKey) return { amount: 0, isComplete: false };
	try {
		return JSON.parse(localKey);
	} catch {
		localStorage.removeItem(key);
		return { amount: 0, isComplete: false };
	}
};

export const rewardKeys = {
	betsUnlocked: (bonusId: number) => `RewardBetsUnlocked--${bonusId}`,
	amountUnlocked: (bonusId: number) => `RewardAmountUnlocked--${bonusId}`,
};

export const getSlipBetTypesLabel = (t: TFunction, allowedSlipBetTypes?: number[] | null): string | null => {
	if (!Array.isArray(allowedSlipBetTypes) || allowedSlipBetTypes.length === 0 || allowedSlipBetTypes.length === 2) {
		return null;
	}

	const typeLabels: Record<number, string> = {
		0: t('akoBetType'),
		100: t('soloBetType'),
	};
	return allowedSlipBetTypes.map((type) => typeLabels[type] ?? String(type)).join(', ');
};
